import styled from "styled-components";

export const ImageComponentStyled = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  .no-image {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #9b9b9b;
    svg {
      width: 50%;
    }
  }
  img,
  svg {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;
